const SET_SWIPER_LEVEL = 'SET_SWIPER_LEVEL';
const SET_DONE_MATERIAL = 'SET_DONE_MATERIAL';
const REMOVE_DONE_MATERIAL = 'REMOVE_DONE_MATERIAL';

export const setDoneMaterial = (data) => (dispatch) => dispatch({ type: SET_DONE_MATERIAL, data });

export const removeDoneMaterial = (
  data
) => (dispatch) => dispatch({ type: REMOVE_DONE_MATERIAL, data });

export const setSwiperCurrentLevel = (data) => (dispatch) => dispatch({
  type: SET_SWIPER_LEVEL,
  data
});
